export const asImage = (canvas, mimeType, quality) => {
  return new Promise((resolve) => {
    let image = canvas.toDataURL(mimeType, quality);
    resolve(image);
  });
};
